<template>
  <div class="campainRange">
    <div class="CampaignBus">
      <div class="CampaignBus__header">
        <div class="CampaignBus__header__left">
          <div class="CampaignBus__header__left__search">
            <i class="adx-ic_search"></i>
            <input type="text" placeholder="Search" class="search" v-model="searchBoxValue">
          </div>
          <adx-dropdown-list class="payment" @selected="selectedPayment" :valueDisplay="selectedPaymentValue" :list="listPayment" labelButton="All Payment" />
          <adx-dropdown-list class="status" @selected="selectedStatus" :valueDisplay="selectedStatusValue" :list="statusList" labelButton="All Status" />
          <button v-if="filtered" class="btn-regular primary" @click="resetFilter">Reset</button>
        </div>
        <div class="CampaignBus__header__right">
          <p>Sort by :</p>
          <div>
            <adx-dropdown-sort :value.sync="selectedSortValue" :type="true" :options="sort"></adx-dropdown-sort>
          </div>
        </div>
      </div>
    </div>
    <adx-table text="Tooltip button" 
      :loading.sync="isLoading"
      :items.sync="data"  
      :isEmpty.sync="isEmpty"  
      @selectedAction="selectedAction">
    </adx-table>
    <div class="range" v-if="!isLoading && !isEmpty">{{getDataRange}} of {{count}} Campaigns</div>
    <adx-pagination 
      v-if="!isLoading && !isEmpty"
      :max-page="maxPage"
      :selected-page="selectedPage"
      @change-page="selectPage"
    />
  </div>
</template>

<script>
import Loading from '@/components/Loading/Primary'
import Pagination from '@/components/Pagination'
import DropdownSort from '@/components/Form/SelectDropdown'
import ListDropdown from '@/components/Dropdown/ListDropdown'
import table from '@/components/Table'
import LabelStatus from '@/components/StatusLabel'

import { parseErrorGql } from '@/lib/error'
import { helpers } from '@/lib/validation/'
import { mapGetters } from 'vuex'

export default {
  name: 'adx-campaign-bus',
  components: {
    'adx-loading': Loading,
    'adx-pagination': Pagination,
    'adx-dropdown-sort': DropdownSort,
    'adx-dropdown-list': ListDropdown,
    'adx-table': table, LabelStatus,
  },
  props: {

  },
  data() {
    return {
      retryCount: 0,
      isLoading: true,
      searchBoxValue:'',
      selectedStatusValue:'',
      selectedStatusLabel:'',
      selectedPaymentValue:'',
      selectedPaymentLabel:'',
      selectedPage: 1,
      currentPage: 1,
      count: 0,
      maxPage: 1,
      selectedSortValue: 'first_added',
      sort: [
        {
          'id': 0,
          'label': 'Created Date',
          'value': 'first_added'
        },
        {
          'id': 1,
          'label': 'Last Updated',
          'value': 'last_updated'
        },
        {
          'id': 2,
          'label': 'Price High to Low',
          'value': '-price'
        },
        {
          'id': 3,
          'label': 'Price Low to High',
          'value': 'price'
        },
      ],
      data: {
        checkbox: false,
        head: [
          {
            title: "ID",
            type: "text"
          },
          {
            title: "STATUS",
            type: "statuslabel"
          },
          {
            title: "CAMPAIGN NAME",
            type: "text"
          },
          {
            title: "PERIOD",
            type: "period"
          },
          {
            title: "PAYMENT",
            type: "statuslabel"
          },
          {
            title: "PRICE",
            type: "money"
          },
          {
            title: "",
            type: "icon"
          },
          {
            title: "",
            type: "icon"
          }
        ],
        body : []
      },
      listPayment: [
        {
          id: 0,
          label: 'All Payment',
          value: null
        },
        {
          id: 1,
          label: 'Pending',
          value: 'pending'
        },
        {
          id: 2,
          label: 'Paid',
          value: 'paid'
        },
        {
          id: 3,
          label: 'Downpayment',
          value: 'dp'
        },
        {
          id: 4,
          label: 'Partially',
          value: 'partially'
        },
        {
          id: 5,
          label: 'Afterpay',
          value: 'afterpay'
        }
      ],
      statusList: [
        {
          id: 0,
          label: 'All',
          value: null
        },
        {
          id: 1,
          label: 'Upcoming',
          value: "upcoming"
        },
        {
          id: 2,
          label: 'Active',
          value: "active"
        },
        {
          id: 3,
          label: 'Expired',
          value: "expired"
        },
        {
          id: 4,
          label: 'Canceled',
          value: "canceled"
        },
      ]
    }
  },
  computed: {
    ...mapGetters({
      token: 'token'
    }),
    isEmpty: function(){
      return this.data.body && this.data.body.length? false: true
    },
    filtered: function() {
      let filtered = false
      if (this.selectedPaymentValue || this.selectedStatusValue) {
        filtered = true
      }
      return filtered
    },
    getDataRange: function(){
      return (this.count%15===0 || this.selectedPage===1) && this.count>15?this.selectedPage*15:(this.selectedPage*15-15)+(this.count%15)
    },
  },
  watch: {
    searchBoxValue: helpers.debounce(function () {
      this.$nextTick(function () {
        this.loadData()
      })
    }, 500),
    selectedSortValue: function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.selectedPage = 1
        this.selectedSortValue = newValue
        this.loadData()
      }
    },
    selectedPaymentValue: function() {
      this.$nextTick(() => {
        this.selectedPage = 1
        this.loadData()
      })
    },
    selectedStatusValue: function() {
      this.$nextTick(() => {
        this.selectedPage = 1
        this.loadData()
      })
    },
  },
  apollo: {

  },
  beforeCreate() {
    
  },
  created() {

  },
  beforeMount() {
    localStorage.setItem('apollo-token', this.token)
  },
  async mounted() {
    const { page } = this.$route.query
    if(page){
      this.selectedPage = parseInt(page)
    }
     await this.loadData()
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    async loadData() {
      this.isLoading = true
      let response = null
      try {
        response = await this.$apollo.query({
          query: require('@/graphql/bus/measurementsPage.gql'),
          fetchPolicy: 'network-only',
          variables: {
            search: this.searchBoxValue || undefined,
            sort: this.selectedSortValue || undefined,
            paymentFilter: this.selectedPaymentValue || undefined,
            statusFilter: this.selectedStatusValue || undefined,
            page: this.selectedPage.toString() || "1"
          },
        })
      } catch(err) {
        this.$notify({
          group: 'saved',
          title: 'Error',
          text: `Network error!`,
          type: 'danger'
        });
        this.$router.push({ name: `500` })
      }

      if (response.data) {
        if (response.errors) {
          this.handleError(response.errors)
        } else {
          const { busCampaignMeasurementsPage } = response.data
          if (busCampaignMeasurementsPage){
            this.mapData(busCampaignMeasurementsPage)
          }
        }
      }
    },
    async handleError(error) {
      const parsedError = parseErrorGql(error)
      if (parsedError.hasError){
        if (parsedError.code === 403 || parsedError.code === 404 || parsedError.code === 204){
          let code = parsedError.code
          if (parsedError.code === 204) code = 404
          this.$router.push({ name: `${code}` })
        }else if (parsedError.code === 502){
          this.retryCount++
          if (this.retryCount<3) {
            await this.loadData()
          } else{
            this.isLoading = false
            this.isEmpty=true
            this.$notify({
              group: 'saved',
              title: 'Error',
              text: `Something went wrong. Please refresh the page!`,
              type: 'danger'
            });
          } 
        }else {
          this.$router.push({ name: `500` })
        }
      }
    },
    async mapData(busCampaignMeasurementsPage){
      let body = []
      let result = busCampaignMeasurementsPage.campaignMeasurements
      let meta = busCampaignMeasurementsPage.meta
      await result.forEach(res => {
        let statusDisplay = this.getStatusDisplay(res.status)
        let statusPaymentDisplay = this.getStatusPaymentDisplay(res.payment)
        let valuesData = [
          { value: res.id},
          { value: statusDisplay.value, label: statusDisplay.label},
          { value: res.campaign},
          { start: res.start, end:res.end},
          { value: statusPaymentDisplay.value, label: statusPaymentDisplay.label},
          { value: parseInt(res.price)},
          { icon: "icon-eye", text: "View Detail"},
          { icon: "icon-copy", text: "View Report", isDisabled: false}
        ]
        body.push({
          id: res.id,
          values:valuesData
        })
      });
      this.data.body = body
      this.maxPage = meta.maxPage
      this.count = meta.count
      this.isLoading = false
    },
    countRoutes(item) {
      let count = 0
      if(item) {
        item.forEach(route => {
          count += route.count
        });
      }
      return count
    },
    displayTotalItem(item) {
      if (item == 0) {
        return '-'
      } else if (item == 1){
        return `${item.length} Buses`
      } else {
      return `${item} Buses`
      }
    },
    getStatusDisplay(status){
      let state = status.toLowerCase()
      let res = []
      switch(state){
        case `draft`:
          res = { id: 0, value: 'draft', label: 'DRAFT', status: 'draft'}
          break
        case `verifying`:
          res = { id: 1, value: 'verifying', label: 'VERIFYING', status: 'verifying'}
          break
        case `active`:
          res = { id: 2, value: 'active', label: 'ACTIVE', status: 'active'}
          break
        case `expired`:
          res = { id: 3, value: 'expired', label: 'EXPIRED', status: 'expired'}
          break
        case `cancel`:
          res = { id: 4, value: 'cancel', label: 'CANCELED', status: 'cancel'}
          break
        case `dormant`:
          res = { id: 5, value: 'dormant', label: 'DORMANT', status: 'dormant'}
          break
        case `upcoming`:
          res = { id: 4, value: 'upcoming', label: 'UPCOMING', status: 'upcoming'}
      }
      return res
    },
    getStatusPaymentDisplay(status){
      let state = status.toLowerCase()
      let res = []
      switch(state){
        case `pending`:
          res = { id: 0, value: 'pending', label: 'PENDING', status: 'pending'}
          break
        case `afterpay`:
          res = { id: 1, value: 'afterpay', label: 'AFTERPAY', status: 'afterpay'}
          break
        case `paid`:
          res = { id: 2, value: 'paid', label: 'PAID', status: 'paid'}
          break
        case `downpayment`:
          res = { id: 3, value: 'downpayment', label: 'DOWNPAYMENT', status: 'downpayment'}
          break
        case `partially`:
          res = { id: 4, value: 'partially', label: 'PARTIALLY', status: 'partially'}
      }
      return res
    },
    selectedPayment(item){
      this.selectedPaymentValue = item.value
      this.selectedPaymentLabel = item.id.toString()
    },
    selectedStatus(item){
      this.selectedStatusValue = item.value
      this.selectedStatusLabel = item.id.toString()
    },
    async resetFilter(){
      this.selectedPage = 1
      this.selectedPaymentValue = '',
      this.selectedPaymentLabel = '',
      this.selectedStatusValue = '',
      this.selectedStatusLabel = ''
      await this.loadData()
    },
    selectedAction(id, type, item){
      let label = item.values[1].value
      let campaign = item.values[2].value
      let start = item.values[3].start
      let end = item.values[3].end
      if(type == 'icon-eye'){
        this.$router.push({name: 'buscampaigndetail', params: { id: item.id }})
      } else if(type == 'icon-copy'){
        this.$router.push({name: 'busreport', params: { id: item.id }})
      } else{
        this.$router.push({name: 'home'})
      }
    },
    async selectPage(item) {
      this.selectedPage = item
      await this.loadData()
    },
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>
<style lang='scss'>
.campainRange{
    .table table tbody tr td .text{
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      text-overflow: ellipsis;
      overflow: hidden;
      max-width: 200px;
      min-width: 50px;
    }
  }
</style>